"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("firebase/firestore");
/**
 * Retorna un appointment de acuerdo a su assignationId
 *
 * @param firestore
 * @param assignationId assignationId del appointment
 * @param country país, sirve para encontrar la ruta en la DB
 * @returns appointment
 */
async function getAppointmentByAssignId(firestore, assignationId, country) {
    const appointmentPath = {
        "AR": "assignations/online_clinica_medica/bag/",
        [country]: `assignations/bag/${country}/`
    };
    const appointmentRef = (0, firestore_1.doc)(firestore, appointmentPath[country], assignationId);
    let appointment;
    try {
        appointment = await (0, firestore_1.getDoc)(appointmentRef);
    }
    catch (err) {
        throw new Error(`${err}`);
    }
    if (appointment) {
        return appointment.data();
    }
    return null;
}
exports.default = getAppointmentByAssignId;
